module.exports = __webpack_public_path__ + "resources/img/img_tcc_spec.16f79b34749971de94b805c6d087c88f.jpg";